module.exports = __webpack_public_path__ + "img/epidemic_bottom.18eeed76.png";